/* PINGEQUA AOV core: tier banner + checkout note. Shared helpers on window.AOV. */
(function () {
  const S = window.Shopify || {};
  const rate = () => +((S.currency && S.currency.rate) || 1);
  const fmt = (c) => { const cur = (S.currency && S.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, minimumFractionDigits: (c % 100 === 0 ? 0 : 2) }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); } };
  const cfg = (el) => { const r = rate(), d = el.dataset, m = (v) => Math.round(+v * 100 * r);
    return { t1: m(d.t1), t2: m(d.t2), s1: m(d.s1), s2: m(d.s2), ship: d.ship ? m(d.ship) : 0, sub: +d.subtotal || 0 }; };
  const root = () => (S.routes && S.routes.root) || '/';
  const getCart = () => fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const saving = (c, sub) => (sub >= c.t2 ? c.s2 : sub >= c.t1 ? c.s1 : 0);
  const onCartUpdate = (fn) => { document.addEventListener('cart:aov-refresh', fn);
    let u = null; if (window.subscribe && window.PUB_SUB_EVENTS) u = window.subscribe(PUB_SUB_EVENTS.cartUpdate, fn);
    return () => { document.removeEventListener('cart:aov-refresh', fn); if (u) u(); }; };
  window.AOV = { fmt, cfg, getCart, saving, onCartUpdate, root };

  class AovTierBar extends HTMLElement {
    connectedCallback() { this.c = cfg(this); this.render(this.c.sub); this.off = onCartUpdate(() => getCart().then((x) => this.render(x.items_subtotal_price)).catch(() => {})); }
    disconnectedCallback() { if (this.off) this.off(); }
    render(sub) {
      const c = this.c; if (!(sub > 0) || !(c.t2 > 0)) { this.hidden = true; return; } this.hidden = false;
      const msg = this.querySelector('.aov-bar__msg'); let html;
      if (sub < c.t1) html = `You're <strong>${fmt(c.t1 - sub)}</strong> away from <strong>${fmt(c.s1)} off</strong> this order`;
      else if (sub < c.t2) html = `<strong>${fmt(c.s1)} off</strong> unlocked. Add <strong>${fmt(c.t2 - sub)}</strong> more for <strong>${fmt(c.s2)} off</strong>`;
      else html = `<strong>${fmt(c.s2)} off</strong> unlocked on this build`;
      msg.innerHTML = html;
      this.classList.toggle('is-done', sub >= c.t2); this.classList.toggle('is-mid', sub >= c.t1 && sub < c.t2);
      const pct = Math.min(100, (sub / c.t2) * 100);
      this.querySelector('.aov-bar__fill').style.width = pct + '%';
      const tr = this.querySelector('.aov-bar__track'); tr.setAttribute('aria-valuenow', Math.round(pct));
      const m1 = this.querySelector('.aov-bar__ms--1'), m2 = this.querySelector('.aov-bar__ms--2');
      m1.style.left = (c.t1 / c.t2) * 100 + '%'; m1.classList.toggle('is-hit', sub >= c.t1); m1.querySelector('b').textContent = `${fmt(c.t1)} · −${fmt(c.s1)}`;
      m2.classList.toggle('is-hit', sub >= c.t2); m2.querySelector('b').textContent = `${fmt(c.t2)} · −${fmt(c.s2)}`;
      const sh = this.querySelector('.aov-bar__ship');
      if (c.ship) sh.innerHTML = sub < c.ship ? `Add <strong>${fmt(c.ship - sub)}</strong> for free tracked shipping` : '✓ Free tracked shipping on this order';
      else sh.textContent = '';
      sh.hidden = !c.ship;
    }
  }
  class AovCheckoutNote extends HTMLElement {
    connectedCallback() { this.c = cfg(this); this.render(this.c.sub); this.off = onCartUpdate(() => getCart().then((x) => this.render(x.items_subtotal_price)).catch(() => {})); }
    disconnectedCallback() { if (this.off) this.off(); }
    render(sub) {
      const c = this.c, t = this.querySelector('.aov-note__text'); if (!(sub > 0)) { this.hidden = true; return; } this.hidden = false;
      const sv = saving(c, sub);
      t.innerHTML = sub < c.t1 ? `Add <strong>${fmt(c.t1 - sub)}</strong> to save ${fmt(c.s1)} at checkout`
        : sub < c.t2 ? `Saving ${fmt(sv)} at checkout · <strong>${fmt(c.t2 - sub)}</strong> more saves ${fmt(c.s2)}`
        : `Saving <strong>${fmt(sv)}</strong> at checkout`;
      this.classList.toggle('is-done', sv > 0);
    }
  }
  if (!customElements.get('aov-tier-bar')) customElements.define('aov-tier-bar', AovTierBar);
  if (!customElements.get('aov-checkout-note')) customElements.define('aov-checkout-note', AovCheckoutNote);
})();
